export enum CostingProfileDetailsTab {
  ACCESS = 'access',
  COSTING_CALCULATION = 'costing-calculation',
  VENDOR_QUOTES = 'vendor-quotes',
}
